import { Player } from "@uno/protocol";
import { create } from "zustand";

type AuthDispatchers = {
    setToken: (token: string | null) => void;
    setNonce: (nonce: number) => void;
};

type StateStorePlayer = {
    player: Player | null;
    locked: boolean;
};

type StorePlayerActions = {
    setPlayer: (player: Player | null) => void;
    lock: () => void;
    unlock: () => void;
    register: (dispatchers: AuthDispatchers) => void;
    refreshSession: () => void;
    logout: () => void;
};

let _auth: AuthDispatchers | null = null;

const useStorePlayer = create<StateStorePlayer & StorePlayerActions>((set) => ({
    player: null,
    locked: false,

    setPlayer: (player) => set(() => ({ player })),
    lock: () => set(() => ({ locked: true })),
    unlock: () => set(() => ({ locked: false })),

    register: (dispatchers) => {
        _auth = dispatchers;
    },

    refreshSession: () => {
        _auth?.setNonce(Math.random());
    },

    logout: () => {
        _auth?.setToken(null);
        _auth?.setNonce(Math.random());
        set(() => ({ player: null }));
    },
}));

export default useStorePlayer;
